import { tv } from "tailwind-variants";

export const smallTimestampStyle = tv({
  base: "shrink-0 text-xs whitespace-nowrap text-gray-600",
});
